import ApiService from '@/services/core/api.service'

const DepartmentService = {
  async get (query) {
    return ApiService.get(`admin/departments?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/departments', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/departments/${payload.id}`, payload)
  }
}

export default DepartmentService
